export var _APP_DATA: IAppData = {} as any;

